// payment status, following from backend
export const PAYMENT_STATUS = Object.freeze({
	UNPAID: 'unpaid',
	PENDING: 'pending',
	FAILED: 'failed',
	EXPIRED: 'expired',
	PAID: 'paid',
	COD: 'cod',
	PAT_AT_STORE: 'pay_at_store',
});

// payment status options, following from backend
export const PAYMENT_STATUS_OPTIONS = Object.freeze([
	{
		name: 'All statuses',
		value: null,
	},
	{
		name: 'Pending',
		value: PAYMENT_STATUS.PENDING,
	},
	{
		name: 'Failed',
		value: PAYMENT_STATUS.FAILED,
	},
	{
		name: 'Expired',
		value: PAYMENT_STATUS.EXPIRED,
	},
	{
		name: 'Paid',
		value: PAYMENT_STATUS.PAID,
	},
	{
		name: 'COD',
		value: PAYMENT_STATUS.COD,
	},
	{
		name: 'Pay at store',
		value: PAYMENT_STATUS.PAT_AT_STORE,
	},
]);
